import type { ReactNode } from 'react';

/**
 * Renders phone/email/website as real, safe, clickable links — tel:/
 * mailto:/https: only, per brief #19/#27. Never accepts a javascript: URL:
 * anything not matching an allowed scheme renders as plain text instead
 * of a link.
 */
export function SafeLink({ href, children }: { href?: string; children: ReactNode }) {
  if (!href) return <>—</>;
  const safe = /^(https:\/\/|mailto:|tel:)/i.test(href) ? href : /^www\./i.test(href) ? `https://${href}` : null;
  if (!safe) return <>{children}</>;
  return (
    <a href={safe} target={safe.startsWith('http') ? '_blank' : undefined} rel={safe.startsWith('http') ? 'noopener noreferrer' : undefined} className="safe-link">
      {children}
    </a>
  );
}
